/* eslint-disable @typescript-eslint/no-explicit-any */

import * as React from 'react'
import Box from '@mui/material/Box'

import { useSelector } from 'react-redux'
import { RootState } from 'src/store/store'

import Ambassador from 'src/components/pages/becomeAmmbasador/becomeAmmbasasdor'
import { apiFetch } from '../service/api.service'

interface IProps {
  data: any
}
export default function AmbassadorPage({ data }: IProps) {
  const zenMode = useSelector((state: RootState) => state.zenModeState.zenMode)

  return (
    <Box component="div">
      <Ambassador zenMode={zenMode} data={data} />
    </Box>
  )
}

// This gets called on every request
export async function getServerSideProps() {
  // Fetch data from external API
  const baseURL =
    process.env.NEXT_PUBLIC_BACKEND_URL ||
    'https://strapi-beta.ditchthelabel.org'
  const endPoint =
    process.env.NEXT_PUBLIC_SITE_LANGUAGE === 'en'
      ? `/api/article-schemas?filters[name][$eq]=becomeAnAmbassador&populate=deep`
      : `/api/article-schemas?filters[name][$eq]=mx-becomeAnAmbassador&populate=deep&locale=es-MX`
  const url = baseURL + endPoint

  const data = await apiFetch(url)

  // Pass data to the page via props
  return { props: { data } }
}
